import axios from "./axiosInstance";

export const getSchoolsDropdown = async () => {
  try {
    const response = await axios.get("/dashboard/schools");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getStats = async (sc_id) => {
  try {
    const response = await axios.get(`/dashboard/stats/${sc_id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
